import { Action, Dispatch } from 'redux'
import { togglePrivateAction } from 'reducks/bread/actions'
import { State } from 'index'

const toggleShownPrivateBreads = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const isShownPrivate = getState().bread.isShownPrivate
    dispatch(togglePrivateAction(!isShownPrivate))
  }
}

export default toggleShownPrivateBreads
